/**
Copyright (C) 2019-2025, Infraclear Inc. All Rights Reserved.
*/

import instance from '../../../utils/axiosInstance';
import {
  AdminMcpSubscriptions,
  AdminMcpSubscriptionById,
  AdminMcpSubscriptionsByClient,
  AdminMcpSubscriptionCancel,
} from '../../../constants/api-urlConstants';
import {
  McpSubscription,
  CreateMcpSubscriptionPayload,
  UpdateMcpSubscriptionPayload,
} from './types';

export const fetchMcpSubscriptions = (): Promise<McpSubscription[]> => {
  return instance.get(AdminMcpSubscriptions).then((response) => response.data.data ?? response.data);
};

export const fetchMcpSubscriptionById = (subscriptionId: number): Promise<McpSubscription> => {
  return instance.get(AdminMcpSubscriptionById(subscriptionId)).then((response) => response.data.data ?? response.data);
};

export const fetchMcpSubscriptionsByClient = (clientId: number): Promise<McpSubscription[]> => {
  return instance.get(AdminMcpSubscriptionsByClient(clientId)).then((response) => response.data.data ?? response.data);
};

export const createMcpSubscription = (payload: CreateMcpSubscriptionPayload): Promise<McpSubscription> => {
  return instance.post(AdminMcpSubscriptions, payload).then((response) => response.data.data ?? response.data);
};

export const updateMcpSubscription = (payload: UpdateMcpSubscriptionPayload): Promise<McpSubscription> => {
  return instance.put(AdminMcpSubscriptions, payload).then((response) => response.data.data ?? response.data);
};

export const cancelMcpSubscription = (subscriptionId: number): Promise<void> => {
  return instance.post(AdminMcpSubscriptionCancel(subscriptionId)).then(() => undefined);
};
